/**
 * 下载表格
 *
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    class: string;
    params: string;
}
export interface IOutput {
    status: number;
    download_url: string;
}

export const downloadFile = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.OUTPUT_REPORT, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
